import React from "react";
import { ProgramData, AllProgressCheckStatuses, ProgressCheck, IEvidence } from "@interfaces/Interfaces";
import * as ProgramUtils from "@utils/programUtils";
import { Image_Completion } from "@assets/images";

type Props = {
  level: string;
  program: ProgramData;
  progressCheckData?: AllProgressCheckStatuses[];
  progressChecks?: ProgressCheck[];
  programEvidence: IEvidence[];
};

const UOCApprenticeshipOverview: React.FC<Props> = (props) => {
  const userLevel = props.level ?? props.program.Levels?.[0] ?? "";

  if (
    ProgramUtils.isProgramCompleteNQP(
      props.progressChecks,
      props.progressCheckData,
      props.programEvidence,
      props.program?.ID
    )
  ) {
    return (
      <div className="flex flex-col">
        <div className="text-[13px] font-acc-normal leading-default tracking-[-0.05px] text-grey-90">
          {props.program?.CompletionText ?? `You've completed your ${props.program?.Title} program. Well done!`}
        </div>
        <img
          className="mt-[10px] h-[112px] w-[160px] shrink-0 self-center"
          src={Image_Completion}
          alt="Completion"
        />
      </div>
    );
  }

  return (
    <div className="mb-1 mt-2">
      <div className="text-acc-13px leading-[1.54] tracking-[-0.1px] text-grey-70">{"Your level"}</div>
      <div className="text-acc-17px leading-[1.53] tracking-[-0.3px] text-grey-90">{userLevel}</div>
    </div>
  );
};

export default UOCApprenticeshipOverview;
